"use client";

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Zap, Shield, Clock } from 'lucide-react';

export const Advantages = () => {
  const { t } = useTranslation();

  return (
    <section id="advantages" className="py-20 bg-gradient-to-br from-blue-600/20 to-purple-700/20">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12 text-gradient text-glow">{t('advantages.title')}</h2>
        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white/5 backdrop-blur-sm text-center p-8 rounded-xl border border-white/10 transition-all duration-300 hover:bg-white/10 hover:scale-105">
            <Zap className="w-12 h-12 text-blue-300 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2 text-white">{t('advantages.modern.title')}</h3>
            <p className="text-blue-200/80">{t('advantages.modern.desc')}</p>
          </div>
          <div className="bg-white/5 backdrop-blur-sm text-center p-8 rounded-xl border border-white/10 transition-all duration-300 hover:bg-white/10 hover:scale-105">
            <Shield className="w-12 h-12 text-purple-300 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2 text-white">{t('advantages.professional.title')}</h3>
            <p className="text-blue-200/80">{t('advantages.professional.desc')}</p>
          </div>
          <div className="bg-white/5 backdrop-blur-sm text-center p-8 rounded-xl border border-white/10 transition-all duration-300 hover:bg-white/10 hover:scale-105">
            <Clock className="w-12 h-12 text-blue-300 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2 text-white">{t('advantages.fast.title')}</h3>
            <p className="text-blue-200/80">{t('advantages.fast.desc')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};